import { ONE_DAY_IN_SECONDS, ONE_HOUR_IN_SECONDS, toTwoDigits } from '../apps/professional-app/fa/common/aifeatures/utils'

const getFormattedTimeInterval = (timeIntervalInSeconds: number, twoDigits: boolean = true) => {
  const days = Math.floor(timeIntervalInSeconds / ONE_DAY_IN_SECONDS)
  const hours = Math.floor((timeIntervalInSeconds % ONE_DAY_IN_SECONDS) / 3600)
  const minutes = Math.floor((timeIntervalInSeconds % ONE_HOUR_IN_SECONDS) / 60)
  const seconds = Math.floor(timeIntervalInSeconds % 60)

  return (
    `${days ? `${days} days ` : ''}${hours ? `${twoDigits ? toTwoDigits(hours) : hours} hours ` : ''}` +
    `${!days && !hours && !minutes ? `${twoDigits ? toTwoDigits(seconds) : seconds} seconds` : `${twoDigits ? toTwoDigits(minutes) : minutes} minutes`}`
  )
}

const getFormattedDuration = (startedAt: string, finishedAt?: string) => {
  if (!finishedAt) {
    return 'Live'
  }
  const startedAtDate = new Date(startedAt)
  const finishedAtDate = new Date(finishedAt)
  const diffInSec = (finishedAtDate.getTime() - startedAtDate.getTime()) / 1000
  return getFormattedTimeInterval(diffInSec)
}

const humanizeRemainingTime = (startTime: Date, now: Date) => {
  const isPast = startTime.getTime() - now.getTime() < 0
  const diffInMin = Math.abs(Math.floor((startTime.getTime() - now.getTime()) / 1000 / 60))
  const diffInHour = Math.floor(diffInMin / 60)
  const diffInDay = Math.floor(diffInHour / 24)
  let duration = ''
  if (diffInDay >= 1) {
    const startDateMidnight = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), 0, 0, 0)
    const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
    const daysDiff = Math.abs(Math.floor((startDateMidnight.getTime() - todayMidnight.getTime()) / 1000 / 60 / 60 / 24))
    duration = `${daysDiff} ${daysDiff > 1 ? 'days' : 'day'}${isPast ? ' ago' : ''}`
    return duration
  }
  if (diffInHour >= 1) {
    duration = `${diffInHour} ${diffInHour > 1 ? 'hours' : 'hour'}`
    if (diffInMin % 60 > 0) {
      duration += ` and ${diffInMin % 60} ${diffInMin % 60 > 1 ? 'minutes' : 'minute'}${isPast ? ' ago' : ''}`
    } else if (isPast) {
      duration += `${isPast ? ' ago' : ''}`
    }
    return duration
  }
  if (diffInMin === 0) {
    return 'now'
  }
  duration = `${diffInMin} ${diffInMin > 1 ? 'minutes' : 'minute'}${isPast ? ' ago' : ''}`
  return duration
}

const getFormattedDurationShort = (start: string, end: string) => {
  const startDate = new Date(start)
  const endDate = new Date(end)
  const diffInSec = (endDate.getTime() - startDate.getTime()) / 1000
  const days = Math.floor(diffInSec / ONE_DAY_IN_SECONDS)
  const hours = Math.floor((diffInSec % ONE_DAY_IN_SECONDS) / 3600)
  const minutes = Math.floor((diffInSec % ONE_HOUR_IN_SECONDS) / 60)
  const seconds = Math.floor(diffInSec % 60)

  return `${days ? `${days}d ` : ''}${hours ? `${toTwoDigits(hours)}h ` : ''}${minutes ? `${toTwoDigits(minutes)}m ` : ''}${seconds ? `${toTwoDigits(seconds)}s ` : ''}`
}

export { getFormattedTimeInterval, getFormattedDuration, getFormattedDurationShort, humanizeRemainingTime }
